<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <div slot="operations">
          <el-form inline label-width="100px">
            <el-form-item :label="$t('CargoMsg.Cargo_BusinessNo')">
              <el-input v-model="form.jobNo" style="width: 200px" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Customer')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{customer:true}"
                callback-method-type="value"
                :default-value="form.customerId"
                :callback-params="{key:'customerId'}"
                style="width: 200px"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Mbl2')">
              <el-input v-model="form.mbl" style="width: 200px" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchClickHandler">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
            </el-form-item>
            <br>

            <el-form-item :label="$t('SeaExport.Carrier')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true,active:true}"
                callback-method-type="value"
                :default-value="form.carrierId||''"
                :callback-params="{key:'carrierId'}"
                style="width: 200px;"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BusinessType')">
              <el-select v-model="form.lob" style="width: 200px">
                <el-option :label="$t('CargoMsg.Cargo_PleaseSelectP')" value="" />
                <el-option :label="$t('CargoMsg.Cargo_OceanExport')" value="SE" />
                <el-option :label="$t('CargoMsg.Cargo_AirExport')" value="AE" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_FlightVoyage')">
              <el-input v-model="form.flight" style="width: 200px" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="finishedClickHandler">{{ $t('SeaExport.Completed') }}</el-button>
            </el-form-item>
            <br>

            <el-form-item :label="$t('CargoMsg.Cargo_OperationRequirementType')">
              <el-select v-model="form.dropRequirementType" style="width: 200px">
                <el-option :label="$t('CargoMsg.Cargo_PleaseSelectP')" :value="-1" />
                <el-option :label="$t('CargoMsg.Cargo_Storage')" :value="1" />
                <el-option :label="$t('CargoMsg.Cargo_Transportation')" :value="2" />
                <el-option :label="$t('CargoMsg.Cargo_CustomsDeclaration')" :value="3" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_Finished')">
              <el-select v-model="form.finishedState" style="width: 200px">
                <el-option :label="$t('CargoMsg.Cargo_PleaseSelectP')" :value="-1" />
                <el-option :label="$t('CargoMsg.Cargo_Yes')" :value="1" />
                <el-option :label="$t('CargoMsg.Cargo_No')" :value="0" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_SailingDate')">
              <el-date-picker v-model="form.etdMin" type="date" value-format="yyyy-MM-dd" style="width: 100px" @change="dateChangeHandler" />
              <el-date-picker v-model="form.etdMax" type="date" value-format="yyyy-MM-dd" style="width: 100px" @change="dateChangeHandler" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="resetHandler">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="searchClickHandler"
          />
        </div>
        <finished-window
          :visible.sync="finishedWindowVisible"
          @saveCallBack="saveCallBackHandler"
        />
      </div>
    </div>
  </div>
</template>

<script>
import importChargeTab from '@/components/Cargo/Job/importCharge/importChargeTab'
import ColumnUtils from '@/utils/ColumnUtils'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import finishedWindow from '@/views/cargo/v0/AirExport/OperationTrack/component/finishedWindow'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import * as operationRequirementApi from '@/api/AirExport/operationRequirement'
import { getLoading } from '@/utils/utilBaseElement'
import DateUtils from '@/utils/dateUtils'
import { formatNumberToThousands } from '@/utils'
import { exportExcel, exportPdf } from '@/utils/tableDataExportUtils'

export default {
  name: 'OperationTrack',
  components: { importChargeTab, cargoAdvanceSelect, finishedWindow },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        },
        rowHeight: 300,
        suppressContextMenu: false, // 右键列表弹出菜单
        getContextMenuItems: (params) => {
          const self = this
          return [
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport') + this.$t('AirExport.CurrentlySelected'),
              action: function() {
                self.exportExcelSelectedHandler()
              }
            },
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport') + this.$t('AirExport.CurrentPage'),
              action: function() {
                self.exportExcelHandler()
              }
            },
            {
              name: self.$t('CargoMsg.Cargo_DataExportPDF') + this.$t('AirExport.CurrentlySelected'),
              action: function() {
                self.exportPdfSelectedHandler(params)
              }
            },
            {
              name: self.$t('CargoMsg.Cargo_DataExportPDF') + this.$t('AirExport.CurrentPage'),
              action: function() {
                self.exportPdfHandler(params)
              }
            }
          ]
        }
      },
      columnDefs: [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
          field: 'jobNo',
          width: 140
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperationRequirement'),
          field: 'contentDescription',
          width: 140
        },
        {
          headerName: 'MBL',
          field: 'mbl',
          width: 140,
          cellRenderer: params => ColumnUtils.mawbNoLabelFun(params.value)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'customerId',
          width: 140,
          cellRenderer: params => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          field: 'destinationPortCode',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.DocumentationNumberOfPackages'),
          field: 'quantityContract',
          width: 100,
          cellRenderer: params => formatNumberToThousands(params.value, 0)
        },
        {
          headerName: this.$t('SeaExport.DocumentationGrossWeight'),
          field: 'weightContract',
          width: 100,
          cellRenderer: params => formatNumberToThousands(params.value, 1)
        },
        {
          headerName: this.$t('SeaExport.DocumentationVolume'),
          field: 'cubageContract',
          width: 100,
          cellRenderer: params => formatNumberToThousands(params.value, 3)
        },
        {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: 'warehouseNo',
          width: 100
        },
        {
          headerName: this.$t('AirExport.CompletionStatus'),
          field: 'finished',
          width: 100,
          cellRenderer: params => {
            return params.value ? this.$t('AirExport.Completed') : this.$t('AirExport.Uncompleted')
          }
        },
        {
          headerName: this.$t('AirExport.OperationRequirementDescription'),
          field: 'operationContent',
          width: 220,
          cellRenderer: params => {
            return ColumnUtils.lineFeed(params.value, '\n')
          }
        }
      ],
      rowData: [],
      form: {
        jobNo: '',
        customerId: 0,
        mbl: '',
        carrierId: 0,
        lob: '',
        dropRequirementType: -1,
        finishedState: -1,
        flight: '',
        etdMin: '',
        etdMax: '',
        opOffice: 0,
        customState: 0
      },
      filter: {
        total: 0,
        pageSize: 30,
        pageNum: 1
      },
      finishedWindowVisible: false
    }
  },
  methods: {
    searchClickHandler() {
      const params = this.getConditionItem()
      params.pageNum = this.filter.pageNum
      params.pageSize = this.filter.pageSize
      const loading = getLoading()
      operationRequirementApi.queryOperationRequirement(params).then(resp => {
        this.rowData = resp.data.list
        this.filter.total = Number(resp.data.total)
      }).finally(() => loading.close())
    },
    getConditionItem() {
      const item = {}
      // 业务编号
      if (!StrUtils.isEmpty(this.form.jobNo)) {
        item.jobNo = this.form.jobNo
      }
      // 客户
      if (this.form.customerId > 0) {
        item.customerId = this.form.customerId
      }
      // 主单号
      if (!StrUtils.isEmpty(this.form.mbl)) {
        item.mbl = this.form.mbl
      }
      // 船公司
      if (this.form.carrierId > 0) {
        item.carrierId = this.form.carrierId
      }
      // 业务类型
      if (!StrUtils.isEmpty(this.form.lob)) {
        item.lob = this.form.lob
      }
      // 操作要求类型
      if (Number(this.form.dropRequirementType) > 0) {
        item.dropRequirementType = this.form.dropRequirementType
      }
      // 是否完成
      if (this.form.finishedState >= 0) {
        item.finished = this.form.finishedState
      }
      // 船名.航次
      if (!StrUtils.isEmpty(this.form.flight)) {
        item.vessel = this.form.flight
      }
      // 业务日期
      if (!StrUtils.isEmpty(this.form.etdMin)) {
        item.etdMin = this.form.etdMin
      }
      if (!StrUtils.isEmpty(this.form.etdMax)) {
        item.etdMax = this.form.etdMax
      }
      // 分公司
      item.opOffice = this.$store.getters.currentOfficeId
      return item
    },
    finishedClickHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSOR'))
        return
      }
      if (this.checkFinishedState(rows)) {
        this.$message.warning(this.$t('AirExport.CurrentSelectionIncludesCompletedStatus'))
        return
      }
      if (rows.length === 1) {
        this.finishedWindowVisible = true
      } else {
        this.saveCallBackHandler(DateUtils.formatStandardDate(new Date()))
      }
    },
    checkFinishedState(items) {
      for (const item of items) {
        if (item.finished) {
          return true
        }
      }
      return false
    },
    saveCallBackHandler(finishedDate, remarks) {
      const item = {}
      item.finishedDate = finishedDate
      item.finished = 1
      const items = this.gridOptions.api.getSelectedRows()
      item.uuids = items.map(item => item.operationRequirementUUID)
      item.remarks = remarks
      const loading = getLoading()
      operationRequirementApi.updateOperationRequirementState(item).then(resp => {
        this.searchClickHandler()
      }).finally(() => loading.close())
    },
    getValueFromChild(obj) {
      this.form[obj.key] = obj.value
    },
    resetHandler() {
      Object.assign(this.form, this.initForm())
    },
    initForm() {
      return {
        jobNo: '',
        customerId: 0,
        mbl: '',
        carrierId: 0,
        lob: '',
        dropRequirementType: -1,
        finishedState: -1,
        flight: '',
        etdMin: '',
        etdMax: '',
        opOffice: 0,
        customState: 0
      }
    },
    dateChangeHandler() {
      if (this.form.etdMin && this.form.etdMax) {
        if (new Date(this.form.etdMin).getTime() > new Date(this.form.etdMax).getTime()) {
          const tem = this.form.etdMin
          this.form.etdMin = this.form.etdMax
          this.form.etdMax = tem
        }
      }
    },
    exportExcelSelectedHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      this.exportExcelHandler(rows)
    },
    exportExcelHandler(rows) {
      const rowData = rows || this.rowData
      if (!rowData || rowData.length === 0) return
      const columnDefs = []
      this.columnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportExcel(this.$t('AirExport.OperationRequirementTracking'), rowData, columnDefs)
    },
    exportPdfSelectedHandler(params) {
      const rows = this.gridOptions.api.getSelectedRows()
      this.exportPdfHandler(params, rows)
    },
    exportPdfHandler(params, rows) {
      const rowData = rows || this.rowData
      if (!rowData || rowData.length === 0) return
      const columnDefs = params.columnApi.getAllDisplayedColumns()
      exportPdf(this.$t('AirExport.OperationRequirementTracking'), rowData, columnDefs)
    }
  }
}
</script>
